import { IUserPortfoGroupSelectionRow } from "../Interfaces/portfolioGroups";
import { getRequest } from "./requestTemplates";

export const getAllowedSahraAccounts = (): Promise<IUserPortfoGroupSelectionRow[]> =>
  getRequest("/v1/general/allowedSahraAccounts");
